import styled from 'styled-components';
import { MODAL_DESKTOP_BREAKPOINT_PX } from '@/app/components/search/utils/useSsrMedia.ts';

export type TilesPerRow = { mobile: number; desktop: number };

export const TILES_PER_ROW_PROPERTY = '--tiles-per-row';

/**
 * Tiles laid out `perRow` to a row, with a short trailing row stretching to fill: five options at
 * three per row give 3 + 2, at two per row 2 + 2 + 1. The breakpoint is the one `useIsModalViewport`
 * uses for `SLOT.MOBILE_MODAL`, so the modal's own mobile/desktop split decides the count.
 *
 * The count is a custom property rather than an interpolated basis so a test can read it back;
 * jsdom drops a `calc()` basis it cannot parse, but keeps custom properties verbatim.
 */
export const FilterTileRow = styled.div<{ $perRow: TilesPerRow }>`
  ${TILES_PER_ROW_PROPERTY}: ${({ $perRow }) => $perRow.mobile};

  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.kallisto.space.space100};

  > * {
    /* A full row sums to exactly 100%, which a fractional container width can round past and wrap;
       the 0.02px trim absorbs that, and flex-grow puts it straight back. */
    flex: 1 1
      calc(
        (100% - (var(${TILES_PER_ROW_PROPERTY}) - 1) * ${({ theme }) => theme.kallisto.space.space100}) /
          var(${TILES_PER_ROW_PROPERTY}) - 0.02px
      );
    align-self: stretch;
    min-width: 0;
  }

  @media (min-width: ${MODAL_DESKTOP_BREAKPOINT_PX}px) {
    ${TILES_PER_ROW_PROPERTY}: ${({ $perRow }) => $perRow.desktop};
  }
`;
